module.exports = __webpack_public_path__ + "img/flash.b029ec67.svg";